/**
 * Collection Categories – Desktop hover image swap
 * On hover over a category name, crossfade to the corresponding image.
 * Uses event delegation for performance.
 */

(function () {
  'use strict';

  function initCollectionCategories(container) {
    const names = container.querySelectorAll('.collection-categories__name');
    const images = container.querySelectorAll('.collection-categories__image-wrapper');

    if (!names.length || !images.length) return;

    // Only attach hover behaviour on desktop
    const mediaQuery = window.matchMedia('(min-width: 990px)');

    function activateCategory(index) {
      names.forEach((n) => n.classList.remove('is-active'));
      images.forEach((img) => img.classList.remove('is-active'));

      const targetName = container.querySelector(
        `.collection-categories__name[data-category-index="${index}"]`
      );
      const targetImage = container.querySelector(
        `.collection-categories__image-wrapper[data-category-image="${index}"]`
      );

      if (targetName) targetName.classList.add('is-active');
      if (targetImage) targetImage.classList.add('is-active');
    }

    function handleMouseEnter(event) {
      const nameEl = event.target.closest('.collection-categories__name');
      if (!nameEl) return;
      const index = nameEl.getAttribute('data-category-index');
      if (index !== null) activateCategory(index);
    }

    function attachDesktopEvents() {
      names.forEach((name) => {
        name.addEventListener('mouseenter', handleMouseEnter);
      });
    }

    function detachDesktopEvents() {
      names.forEach((name) => {
        name.removeEventListener('mouseenter', handleMouseEnter);
      });
    }

    function onMediaChange(e) {
      if (e.matches) {
        attachDesktopEvents();
      } else {
        detachDesktopEvents();
        // Reset to first active on mobile
        activateCategory(0);
      }
    }

    mediaQuery.addEventListener('change', onMediaChange);
    if (mediaQuery.matches) attachDesktopEvents();
  }

  // Initialise all instances on the page
  function init() {
    document.querySelectorAll('.collection-categories').forEach(initCollectionCategories);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Support Shopify Theme Editor section re-rendering
  if (Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      const container = event.target.querySelector('.collection-categories');
      if (container) initCollectionCategories(container);
    });
  }
})();
